import { createSlice, createAction } from '@reduxjs/toolkit';

export const createUserSignupsReportAction = createAction(
    'userSignupsReports/createReport',
);
export const fetchUserSignupsReportsAction = createAction(
    'userSignupsReports/fetchReports',
);
export const pollUserSignupsReportStatusAction = createAction(
    'userSignupsReports/pollReportStatus',
);
export const stopUserSignupsPollingAction = createAction(
    'userSignupsReports/stopPolling',
);
export const checkExistingUserSignupsReportAction = createAction(
    'userSignupsReports/checkExisting',
);
export const deleteUserSignupsReportAction = createAction(
    'userSignupsReports/deleteReport',
);

const initialState = {
    reports: [],
    total: 0,
    loading: false,
    creating: false,
    activeReport: null,
    existingReport: null,
    checkingExisting: false,
    error: null,
};

const userSignupsReportsSlice = createSlice({
    name: 'userSignupsReports',
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setCreating(state, action) {
            state.creating = action.payload;
        },
        reportsFetched(state, action) {
            state.reports = action.payload.reports;
            state.total = action.payload.total;
            state.loading = false;
        },
        reportCreated(state, action) {
            state.creating = false;
            state.activeReport = action.payload;
            state.reports = [action.payload, ...state.reports];
            state.total += 1;
        },
        reportStatusUpdated(state, action) {
            const report = action.payload;
            state.activeReport = report;
            const idx = state.reports.findIndex(r => r._id === report._id);
            if (idx !== -1) {
                state.reports[idx] = report;
            }
        },
        clearActiveReport(state) {
            state.activeReport = null;
        },
        setExistingReport(state, action) {
            state.existingReport = action.payload;
            state.checkingExisting = false;
        },
        setCheckingExisting(state, action) {
            state.checkingExisting = action.payload;
        },
        reportDeleted(state, action) {
            state.reports = state.reports.filter(r => r._id !== action.payload);
            state.total = Math.max(0, state.total - 1);
        },
        setError(state, action) {
            state.error = action.payload;
            state.loading = false;
            state.creating = false;
        },
    },
});

export const {
    setLoading,
    setCreating,
    reportsFetched,
    reportCreated,
    reportStatusUpdated,
    clearActiveReport,
    reportDeleted,
    setExistingReport,
    setCheckingExisting,
    setError,
} = userSignupsReportsSlice.actions;

export const getUserSignupsReports = state => state.userSignupsReports.reports;
export const getUserSignupsReportsTotal = state =>
    state.userSignupsReports.total;
export const getUserSignupsReportsLoading = state =>
    state.userSignupsReports.loading;
export const getUserSignupsReportsCreating = state =>
    state.userSignupsReports.creating;
export const getActiveUserSignupsReport = state =>
    state.userSignupsReports.activeReport;
export const getExistingUserSignupsReport = state =>
    state.userSignupsReports.existingReport;
export const getCheckingExistingUserSignups = state =>
    state.userSignupsReports.checkingExisting;

export default userSignupsReportsSlice.reducer;
